
import React, { useMemo, useRef, useState } from 'react';
import { Select, Spin, Avatar } from 'antd';
import debounce from 'lodash/debounce';
import { UserOutlined } from '@ant-design/icons';
import { consoleLogUtil } from '../utils/consoleLogUtil';

function DebounceSelectProduct({ fetchOptions, debounceTimeout = 300, ...props }) {
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState([]);
    const fetchRef = useRef(0);
    const debounceFetcher = useMemo(() => {
      const loadOptions = value => {
        fetchRef.current += 1;
        const fetchId = fetchRef.current;
        setOptions([]);
        setFetching(true);
        fetchOptions(value).then(newOptions => {
          if (fetchId !== fetchRef.current) {
            // for fetch callback order
            return;
          }
          setOptions(newOptions);
          consoleLogUtil('DebounceSelect', 'fetchOptions', newOptions);
          setFetching(false);
        });
      };
      return debounce(loadOptions, debounceTimeout);
    }, [fetchOptions, debounceTimeout]);
    return (
      <Select
        labelInValue
        allowClear
        showSearch
        filterOption={false}
        onSearch={debounceFetcher}
        notFoundContent={fetching ? <Spin size="small" /> : 'No results found'}
        {...props}
        options={options}
        optionRender={option => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{paddingLeft: 8}}>{option.label} | Tồn: {option.data?.product?.stock_quantity}</span>
          </div>
        )}
      />
    );
  }

export default DebounceSelectProduct;